import React, { useCallback, useState } from 'react';

import { DialogSecurity } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import { moderatorService } from "../../../../../../service";
import { updateSettings as updateSettingsAction} from "../../../../base/settings";
import { hideEditProfileDialog as hideEditProfileAction} from '../../../../invite';
import { useDispatch } from 'react-redux';
import { Notify } from '../../../components';

type Props = {
};

function ProfileDialog(props) {
    const {updateSettings, hideEditProfileDialog} = props;
    const dispatch = useDispatch();
    const nameRegx = /^[A-Za-z0-9_. ]+$/;
    const emailRegx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    const [errors, setError] = useState({
        fName: '',
        lName: '',
        uName: '',
        email: ''
    })
    const state = APP.store.getState();
    const user = state['features/base/settings'].user;
    const [firstName, setFName] = useState(user.firstName);
    const [lastName, setLName] = useState(user.lastName);
    const [userName, setName] = useState(user.userName);
    const [email, setEmail] = useState(user.verified ? user.email : user.preEmail);
    const [verified, setVerified] = useState(user.verified);

    const updateProfile = useCallback(async (val) => {

        let data = user;
        data.firstName = firstName;
        data.lastName = lastName;
        data.userName = userName;
        data.email = email;

        if(firstName === '') {
            setError({fName: '* First Name is required'})
        } else if(!nameRegx.test(firstName)) {
            setError({fName: '* No numbers or special characters are allowed'})
        } else if(firstName.length > 30) {
            setError({fName: '* Maximum length is 30 characters'})
        } else if(lastName === '') {
            setError({lName: '* Last Name is required'})
        } else if(!nameRegx.test(lastName)) {
            setError({lName: '* No numbers or special characters are allowed'});
        } else if(lastName.length > 30) {
            setError({lName: '* Maximum length is 30 characters'})
        } else if(userName === '') {
            setError({uName: '* User Name is required'})
        } else if(!nameRegx.test(userName)) {
            setError({uName: '* No numbers or special characters are allowed'});
        } else if(userName.length > 30) {
            setError({uName: '* Maximum length is 30 characters'})
        } else if(email === '') {
            setError({email: '* Email is required'})
        } else if(!emailRegx.test(email)) {
            setError({email: '* Check the format of the email you entered'});
        } else if(email.length > 80) {
            setError({email: '* Maximum length is 80 characters'})
        } else {
            setError({fName: '', lName: '', uName: '', email: ''});
            await moderatorService.updateProfile(data)
            .then(resp => {
                if(resp.data.success) {
                    setVerified(resp.data.moderator.verified);

                    Notify({type: 'success', message: val === 'save' ? resp.data.message : "The confirmation email was sent to your inbox."})
                    hideEditProfileDialog();
                    updateSettings({
                        user: resp.data.moderator
                    });
                } else {
                    if(resp.data.message.includes('username')) {
                        setError({uName: resp.data.message});
                    } else {
                        setError({email: resp.data.message});
                    }
                }
            })
            .catch(err => {
                Notify({type: 'error', message: resp.data.message})
            });
        }
    }, [firstName, lastName, userName, email, user, props, setVerified, hideEditProfileDialog, updateSettings])

    const resendCode = useCallback(() => {
        updateProfile('email');
    }, []);

    return (
        <DialogSecurity
            isForm = { true }
            cancelKe = { true }
            y = { 'dialog.close' }
            hideCancelButton = { true }
            submitDisabled = { true }
            titleKey="Edit Profile"
            width = { 'medium' }
        >
            <div className = { 'white-line' } />
            <div className = { 'profile-form' }>
                <div className={'input-item'}>
                    <div className={'input-form'}>
                        <p>First Name:</p>
                        <input placeholder="First Name" value={firstName} onChange={e => setFName(e.target.value)}/>
                    </div>
                    <div className={'error'}>{errors.fName}</div>
                </div>
                <div className={'input-item'}>
                    <div className={'input-form'}>
                        <p>Last Name:</p>
                        <input placeholder="Last Name" value={lastName} onChange={e => setLName(e.target.value)}/>
                    </div>
                    <div className={'error'}>{errors.lName}</div>
                </div>
                <div className={'input-item'}>
                    <div className={'input-form'}>
                        <p>UserName:</p>
                        <input placeholder="User Name" value={userName} onChange={e => setName(e.target.value)}/>
                    </div>
                    <div className={'error'}>{errors.uName}</div>
                </div>
                <div className={'input-item'}>
                    <div className={'input-form'}>
                        <p>Email:</p>
                        <input placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}/>
                    </div>
                    <div className={'error'}>{errors.email}</div>
                    {!verified && <div className={'error'}>The email was not verified. Click <span style={{color: 'blue', textDecoration: 'underline'}} onClick={() => resendCode()}>here</span>  to send the confirmation email</div>}
                </div>
                <div className = { 'invite-guest' }>
                    <button
                        className = { 'invite-btn' }
                        onClick = { () => updateProfile('save') }>Save
                    </button>
                </div>
            </div>
        </DialogSecurity>
    )
}

function mapStateToProps(state, ownProps ) {
    const settings = state['features/base/settings'];
    return {
        user: settings.user
    }
}

const mapDispatchToProps = {
    updateSettings: updateSettingsAction,
    hideEditProfileDialog: hideEditProfileAction
}

export default translate(
    connect(mapStateToProps, mapDispatchToProps)(translate(ProfileDialog))
)